import NotFoundErrorPage from '@atlassian/jira-error-pages/src/ui/not-found-error-page';

export default NotFoundErrorPage;
